<template>
  <div class="add-chapter">
    <WsUpdateMultiLayer
      :modelName="modelName"
      :title="title"
      :label="label"
      :layersSetting="layersSetting"
      :getUrl="$_getUrl"
      :getPayload="$_getPayload"
    ></WsUpdateMultiLayer>
  </div>
</template>
<script>
import model from "@/models/industry_category";
import S_multiLayer from "@/helpers/multiLayer";
export default {
  data(){
    return {
      title: "編輯子產業類別",
      label: "產業類別",
      modelName: model.modelName,
      layersSetting: {
        getLayersKey: 'industry_categories',
        fieldKeys: ['area'],
        fields: {
          btn: [
            {
              text: "新增",
              icon: "mdi-plus",
              color: "primary",
              outline: true,
              isCreateSubLayer: false,
            },
            {
              text: "新增子層",
              icon: "mdi-plus",
              color: "primary",
              outline: true,
              isCreateSubLayer: true,
              $_visibility(layer){
                return layer.layers && layer.layers.length > 0
                ? false
                : true
              },
            }
          ],
          component: "WsTitleInput",
          props: {
            fields: {
              name: {
                label: "",
                type: "text",
                sm: 12,
              },
            },
            description: '請再三確認，此地區以下的子產業類型也會一併刪除。'
          },
        }
      },
    }
  },
  methods: {
    $_getUrl(type, data) {
      let url = ''
      if (type === 'update') {
        url = `industry_category/${data.id}`
      } else if (type === 'delete') {
        url = `industry_category/${data}`
      } else if (type === 'create') {
        url = `industry_category`
      } else if (type === 'sort') {
        url = `industry_category_sequence`
      }
      return url
    },
    $_getPayload(type, data) {
      let result = null
      if (type === "update") {
        result = {
          "locales": {
            "tw": {
              "name": data.name
            }
          }
        }
      } else if (type === "create") {
        result = {
          "industry_category": data.parent_id ? data.parent_id : this.$route.params.id,
          "locales": {
            "tw": {
              "name":  data.name
            }
          }
        }
      } else if (type === "sort") {
        const keys = {
          valueKey: 'id',
          getLayersKey: 'layers',
          setLayersKey: 'industry_categories',
        }
        const resultLayer = S_multiLayer.setItems(data, keys)
        result = { ["industry_categories"] : resultLayer }
      }
      return result
    }
  }
};
</script>